import React from 'react';
import './locality.css';

const Locality = () => {
    return(
    <>
        <section className="popular-locality">
            <div class="container">
                <h2>Popular localities in and around in <b>Kingman, Kansas</b></h2>
                <div className="locality-list">
                    Kingman(12 places)
                    <div className="icon">
                        <i className="fas fa-chevron-right"></i>
                    </div>
                </div>
            </div>
        </section>
    </>
    )
}
export default Locality;